<template>
    <transition name="fade" appear>
        <ul class="picker-1">
            <li @click="sendGA('rezultati')">
                <router-link to="/rezultati">
                    <i><b class="icon-rezultati"></b></i>
                    <span>Rezultati</span>
                </router-link>
            </li>
            <li @click="sendGA('moje-lige')">
                <router-link to="/moje-lige">
                    <i><b class="icon-lige"></b></i>
                    <span>Moje lige</span>
                </router-link>
            </li>
            <li @click="sendGA('kreiraj-ligu')">
                <router-link to="/kreiraj-ligu">
                    <i><b class="icon-kreiraj"></b></i>
                    <span>Kreiraj ligu</span>
                </router-link>
            </li>
            <li @click="sendGA('moje-grupe')">
                <router-link to="/moje-grupe">
                    <i><b class="icon-grupe"></b></i>
                    <span>Moje grupe</span>
                </router-link>
            </li>
            <li @click="sendGA('kreiraj-grupu')">
                <router-link to="/kreiraj-grupu">
                    <i><b class="icon-kreiraj-grupu"></b></i>
                    <span>Kreiraj grupu</span>
                </router-link>
            </li>
            <li @click="sendGA('pravila')">
                <router-link to="/pravila">
                    <i><b class="icon-pravila"></b></i>
                    <span>Pravila</span>
                </router-link>
            </li>
        </ul>
    </transition>
</template>

<script>
export default {
    name: 'poveznice',
    data: function () {
        return {

        }
    },
    methods: {
        sendGA (path) {
            // eslint-disable-next-line no-undef
            gtag('event', 'click', {
                'event_category': 'Glavna navigacija',
                'event_label': path
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.picker-1 {
    display: block;
    padding: 0 0px 14px 25px;
    overflow: hidden;
    overflow-x: auto;
    position: relative;
    margin-left: -15px;
    padding-right: 25px;
    white-space: nowrap;

    li {
        display: inline-block;
        padding-left: 15px;
        outline: none;
    }
    a {
        transition: opacity .4s ease-in-out;
        font-family: 'axiforma';
        perspective: 500px;
        display: block;
        position: relative;
        padding-top: 92px;
        font-size: 11px;
        color: #fff;
        white-space: nowrap;
        font-weight: 600;
        text-align: center;
        letter-spacing: .5px;
        outline: none;
        user-select: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        min-width: 76px;
        opacity: 1;
    }
    a:hover {
        opacity: 0.75;
    }
    a.router-link-active i,
    a.active i {
        background-image: url(~@/assets/img/icons/polygon-4.png);
    }
    i {
        transition: background-image .4s ease;
        position: absolute;
        top: 0;
        left: calc(50% - 38px);
        display: block;
        width: 76px;
        height: 82px;
        background-image: url(~@/assets/img/icons/polygon-3.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50%;
    }
    small {
        position: absolute;
        top: 0;
        right: -8px;
        box-shadow: 0px 9px 10px 0px rgba(255,0,92,0.25);
        background: linear-gradient(135deg, rgba(255,0,132,1) 0%, rgba(255,0,132,1) 42%, rgba(255,0,29,1) 100%);
        display: inline-block;
        font-family: 'axiforma';
        font-weight: 700;
        font-size: 10px;
        color: #fff;
        text-transform: uppercase;
        letter-spacing: 1px;
        padding: 5px 8px 4px;
        border-radius: 6px;
        text-align: center;
    }
    b {
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50%;
    }
}
</style>
